import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdArrowDropright, IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight, FaFingerprint } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import { GiCctvCamera, GiLockedDoor } from "react-icons/gi";
import { MdAddAlert } from "react-icons/md";
import { TbDeviceLandlinePhone } from "react-icons/tb";
import overlay from "../assets/overlay.jpg";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px",
					backgroundImage: `url(${overlay})`,
					backgroundAttachment: "fixed",
					backgroundSize: "cover",
					backgroundPosition: "center",
				}}
			>
				
				<div 
					className="container"
					
				>
					<div className="row">

						<div className="col-md-9 p-3">
							<div className="bg-light rounded mShadow2 p-5">
								<h1 className="text-primary font-bold mt-3" data-aos="fade-down">Zamani Sabios Group - ZSG</h1>
								
								<h1
									style={{
										fontSize: "22px",
										paddingTop: "30px",
										paddingBottom: "30px"
									}}
									className="font-light"
									data-aos="fade-up"
								>
									Zamani Sabios Group is a team of senior professionals with more than 250 years of combined experience across management and technical fields. Established in 2025 in line with Section 64 of the Public Procurement Act 2023 and Regulations 33 to 36 of the Public Procurement Regulations 2024, the group supports Tanzania’s economic and social development goals.
									<br/><br/>
									ZSG works with public, private, and nonprofit institutions, focusing on sustainable, evidence-based solutions. Our members have extensive experience in management, procurement, supply chain, logistics, feasibility studies, impact evaluations, project and programme reviews, institutional capacity development, monitoring and evaluation, legal work, organisational change, policy analysis, financial management, mapping studies, and development cooperation.
								</h1>

								<div className="mt-3 mb-5" data-aos="zoom-out-top">
								
									<button
										className="p-0 bg-primary border rounded"
										style={{
											display: "flex",
											alignItems: "center",
											justifyContent: "space-between",
											overflow: "hidden"
										}}
										onClick={() => {
											appContext.navTo({
												item: 'about_us'
											})
										}}
									>
										<h5 className="text-light font-semi-bold px-3 pt-2">Learn More...</h5>
										<div className="bg-light p-2"><IoMdArrowDropright className="text-primary" size={32}/></div>
									</button>
								</div>
							</div>
							

						</div>


						

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
